/**
 * Express routes under /api/sf/* (auth, query, flows). Set REACT_APP_API_URL at build time for previews/alternate hosts.
 */
const DEFAULT_BDM = 'https://bdm.purelocations.com.au';

export const SF_EXPRESS_API_BASE =
  process.env.REACT_APP_API_URL || `${DEFAULT_BDM}/api/sf`;

/** Host-only BDM URL (image proxy, other /api/* paths). Derived from REACT_APP_API_URL when set. */
export function bdmAppOrigin() {
  const api = (process.env.REACT_APP_API_URL || '').trim();
  if (api) {
    const origin = api.replace(/\/api\/sf\/?$/i, '').replace(/\/$/, '');
    return origin || DEFAULT_BDM;
  }
  return DEFAULT_BDM;
}
